"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitView = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
/**
 * Allows displaying two components side-by-side with a movable divider in the middle to adjust the widths.
 * @param leftViewID This is used when switching component positions. If we don't have a unique ID, we can't know when to change the width of the left-view to the width of the previously right-view.
 * @returns
 */
const SplitView = ({ left, right, leftViewID, initialLeftWidth, hideLeftViewWhenResizing, hideRightViewWhenResizing, minLeftWidth }) => {
    const [leftWidth, setLeftWidth] = (0, react_1.useState)();
    const [_leftViewID, _setLeftViewID] = (0, react_1.useState)(leftViewID);
    const [separatorXPosition, setSeparatorXPosition] = (0, react_1.useState)();
    const [dragging, setDragging] = (0, react_1.useState)(false);
    const splitPaneRef = (0, react_1.createRef)();
    const leftRef = (0, react_1.createRef)();
    const rightRef = (0, react_1.createRef)();
    const onMouseDown = (e) => {
        setSeparatorXPosition(e.clientX);
        setDragging(true);
    };
    const onTouchStart = (e) => {
        setSeparatorXPosition(e.touches[0].clientX);
        setDragging(true);
    };
    const onMove = (clientX) => {
        if (dragging && leftWidth && separatorXPosition) {
            const newLeftWidth = leftWidth + clientX - separatorXPosition;
            setSeparatorXPosition(clientX);
            if (minLeftWidth) {
                if (newLeftWidth < minLeftWidth) {
                    setLeftWidth(minLeftWidth);
                    return;
                }
                if (splitPaneRef.current) {
                    const splitPaneWidth = splitPaneRef.current.clientWidth;
                    if (newLeftWidth > splitPaneWidth - minLeftWidth) {
                        setLeftWidth(splitPaneWidth - minLeftWidth);
                        return;
                    }
                }
            }
            setLeftWidth(newLeftWidth);
        }
    };
    const onMouseMove = (e) => {
        e.preventDefault();
        onMove(e.clientX);
    };
    const onMouseUp = () => {
        setDragging(false);
    };
    react_1.default.useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    });
    (0, react_1.useEffect)(() => {
        if (leftRef.current) {
            // As soon as we get the ref, we can get the actual width *in pixels* of the div.
            // We must do this since we can't do calculations with relative widths given as percentages.
            if (!leftWidth) {
                setLeftWidth(leftRef.current.clientWidth);
                return;
            }
            leftRef.current.style.width = `${leftWidth}px`;
        }
    }, [leftRef, leftWidth, setLeftWidth]);
    (0, react_1.useEffect)(() => {
        console.log(leftViewID, _leftViewID);
        if (_leftViewID !== leftViewID && leftRef.current && rightRef.current) {
            // We now know that the views have been switched (L went to R)
            // and thus we can exchange the widths of their DIVs.
            setLeftWidth(rightRef.current.offsetWidth);
            _setLeftViewID(leftViewID);
        }
    }, [leftViewID]);
    return (react_1.default.createElement("div", { className: 'tr__resizable-split-view', ref: splitPaneRef },
        react_1.default.createElement("div", { className: "tr__resizable-split-view-left-panel", ref: leftRef, style: {
                visibility: hideLeftViewWhenResizing && dragging ? 'hidden' : 'visible',
                width: initialLeftWidth
            } }, left),
        react_1.default.createElement("div", { className: "tr__resizable-split-view-divider-hitbox", onMouseDown: onMouseDown, onTouchStart: onTouchStart, onTouchEnd: onMouseUp },
            react_1.default.createElement("div", { className: "tr__resizable-split-view-divider" })),
        react_1.default.createElement("div", { className: "tr__resizable-split-view-right-panel", ref: rightRef, style: { visibility: hideRightViewWhenResizing && dragging ? 'hidden' : 'visible' } }, right)));
};
exports.SplitView = SplitView;
exports.default = exports.SplitView;
//# sourceMappingURL=SplitView.js.map